import {
  lazy2hsh8ze7j6ikd as lazy,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID3gxj6tk5isa35 as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Long2qws0ah9gnpki as Long,
  constructCallableReference23y65rf941mch as constructCallableReference,
  CancellationException3b36o9qz53rgr as CancellationException,
  printStackTrace18lnx7a39cni as printStackTrace,
  protoOf180f3jzyo7rfj as protoOf,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  shortArrayIteratorvow30nwy4coh as shortArrayIterator,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  containscs3vsq7ynpxl as contains,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  filll361lpxnd2bw as fill,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  coerceIn10f36k81le1mm as coerceIn,
  toShort36kaw0zjdq3ex as toShort,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  contentDeepHashCodei0atlwkd11sc as contentDeepHashCode,
  contentDeepEquals38knrynwk1e6k as contentDeepEquals,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  KProperty02ce7r476m8633 as KProperty0,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from './kotlin-kotlin-stdlib.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  delay3e2ei0hoxjoud as delay,
  Dispatchers_getInstance20p7pyqnrepag as Dispatchers_getInstance,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  launch1c91vkjzdi9sd as launch,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  Deferred6wjx2us769ee as Deferred,
} from './kotlinx-coroutines-core.mjs';
import { get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock } from './kotlinx-atomicfu.mjs';
import { Companion_getInstance1smdz541y8yio as Companion_getInstance } from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  FixedPoolNativeThreadDispatcher1vd3m0y3p4oiv as FixedPoolNativeThreadDispatcher,
  Companion_getInstance385avdqdxp6qt as Companion_getInstance_0,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  Companion_getInstance1ju3fwn4mt9wh as Companion_getInstance_1,
  cancel1n0qjc93h2v6w as cancel,
  Cancellable3gmnln785cfrg as Cancellable,
} from './korlibs-platform-root-korlibs-platform.mjs';
import { convertRangeClamped599b065i5v6s as convertRangeClamped } from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    var tmp = this;
    tmp.thf_1 = lazy(AudioData$Companion$DUMMY$delegate$lambda);
  }
}
class AudioData {
  constructor(rate, samples, name) {
    Companion_getInstance_2();
    name = name === VOID ? null : name;
    this.uhf_1 = new Mixin();
    this.vhf_1 = rate;
    this.whf_1 = samples;
    this.xhf_1 = name;
  }
  o9u(_set____db54di) {
    this.uhf_1.o9u(_set____db54di);
  }
  p9u() {
    return this.uhf_1.p9u();
  }
  yhf() {
    return this.whf_1.zhf_1;
  }
  chg() {
    return this.whf_1.ahg_1;
  }
  dhg(channel, sample) {
    return AudioSampleArray__get_impl_w0l0xc(this.whf_1.bhg_1[channel].ehg_1, sample);
  }
  toString() {
    return 'AudioData(rate=' + this.vhf_1 + ', channels=' + this.yhf() + ', samples=' + this.chg() + ')';
  }
}
class Companion_0 {
  constructor() {
    this.fhg_1 = 2048;
  }
}
class ReadonlySoundProps {}
function get_pitch() {
  return 1.0;
}
class SoundProps {}
function set_pitch(value) {
  return Unit_instance;
}
function get_pitch_0() {
  return 1.0;
}
class AudioPlatformOutput {
  constructor(listener, channels, frequency, gen, dispatcher, block) {
    dispatcher = dispatcher === VOID ? get_AUDIO(Dispatchers_getInstance()) : dispatcher;
    var tmp;
    if (block === VOID) {
      tmp = AudioPlatformOutput$_init_$slambda_5e7gu6(channels);
    } else {
      tmp = block;
    }
    block = tmp;
    this.ghg_1 = new Mixin();
    this.hhg_1 = listener;
    this.ihg_1 = channels;
    this.jhg_1 = frequency;
    this.khg_1 = gen;
    this.lhg_1 = dispatcher;
    this.mhg_1 = block;
    this.nhg_1 = false;
    var tmp_0 = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp_0.ohg_1 = get_atomicfu$reentrantLock();
    this.phg_1 = 1.0;
    this.qhg_1 = 0.0;
    this.rhg_1 = Companion_getInstance().v9t_1;
    this.shg_1 = false;
    this.thg_1 = null;
    this.uhg_1 = false;
  }
  o9u(_set____db54di) {
    this.ghg_1.o9u(_set____db54di);
  }
  p9u() {
    return this.ghg_1.p9u();
  }
  vhg(buffer) {
    // Inline function 'kotlinx.atomicfu.locks.withLock' call
    this.ohg_1;
    try {
      AudioSampleArray__fill$default_impl_gh9lh0(buffer.yhg_1, Companion_getInstance_4().zhg_1);
      this.khg_1(buffer);
      applyPropsTo(this, this.hhg_1, buffer);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  ahh(_set____db54di) {
    this.phg_1 = _set____db54di;
  }
  bhh() {
    return this.phg_1;
  }
  chh(_set____db54di) {
    this.qhg_1 = _set____db54di;
  }
  dhh() {
    return this.qhg_1;
  }
  wb6() {
    return this.rhg_1;
  }
  *ehh($completion) {
    while (this.shg_1)
      yield* delay(new Long(10, 0), $completion);
    return Unit_instance;
  }
  fhh() {
    if (this.shg_1)
      return Unit_instance;
    this.ghh();
    this.uhg_1 = false;
    this.shg_1 = true;
    var tmp0_safe_receiver = this.thg_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.o1n();
    }
    var tmp = this;
    var tmp_0 = CoroutineScope(this.lhg_1.ep(SupervisorJob()));
    tmp.thg_1 = launch(tmp_0, VOID, VOID, AudioPlatformOutput$start$slambda(this));
  }
  ghh() {
    if (!this.shg_1 && !this.uhg_1)
      return Unit_instance;
    this.uhg_1 = true;
    var tmp1_safe_receiver = this.thg_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this.thg_1 = null;
      tmp1_safe_receiver.o1n();
    }
  }
  f7() {
    return this.ghh();
  }
}
class AudioSampleArray$iterator$1 {
  constructor($shortIterator) {
    this.lhh_1 = $shortIterator;
  }
  q1() {
    return this.lhh_1.q1();
  }
  mhh() {
    return this.nhh();
  }
  r1() {
    return new AudioSample(this.mhh());
  }
  nhh() {
    return _AudioSample___init__impl__s54gd5(this.lhh_1.u5());
  }
}
class AudioSampleArray {
  constructor(data) {
    this.ehg_1 = data;
  }
  s2() {
    return _AudioSampleArray___get_size__impl__8l8tm8(this.ehg_1);
  }
  n1() {
    return AudioSampleArray__isEmpty_impl_81zmbn(this.ehg_1);
  }
  p1() {
    return AudioSampleArray__iterator_impl_qvmfbu(this.ehg_1);
  }
  ohh(elements) {
    return AudioSampleArray__containsAll_impl_ohplb0(this.ehg_1, elements);
  }
  r4(elements) {
    return AudioSampleArray__containsAll_impl_ohplb0_0(this, elements);
  }
  phh(element) {
    return AudioSampleArray__contains_impl_pmajf9(this.ehg_1, element);
  }
  w2(element) {
    return AudioSampleArray__contains_impl_pmajf9_0(this, element);
  }
  toString() {
    return AudioSampleArray__toString_impl_il1zfs(this.ehg_1);
  }
  hashCode() {
    return AudioSampleArray__hashCode_impl_363xd3(this.ehg_1);
  }
  equals(other) {
    return AudioSampleArray__equals_impl_jso1e3(this.ehg_1, other);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.zhg_1 = _AudioSample___init__impl__s54gd5_0(0);
  }
}
class AudioSample {
  constructor(raw) {
    Companion_getInstance_4();
    this.jhh_1 = raw;
  }
  toString() {
    return AudioSample__toString_impl_8zwv0h(this.jhh_1);
  }
  hashCode() {
    return AudioSample__hashCode_impl_cr91se(this.jhh_1);
  }
  equals(other) {
    return AudioSample__equals_impl_tcgo7i(this.jhh_1, other);
  }
}
class AudioSamples {
  constructor(channels, totalSamples, data) {
    var tmp;
    if (data === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = Array(channels);
      while (tmp_0 < channels) {
        var tmp_2 = tmp_0;
        var tmp$ret$1 = _AudioSampleArray___init__impl__qpxoq0_0(totalSamples);
        tmp_1[tmp_2] = new AudioSampleArray(tmp$ret$1);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = data;
    }
    data = tmp;
    this.zhf_1 = channels;
    this.ahg_1 = totalSamples;
    this.bhg_1 = data;
  }
  qhh(channel) {
    return this.bhg_1[channel].ehg_1;
  }
  hashCode() {
    return (this.zhf_1 + imul(this.ahg_1, 32) | 0) + imul(contentDeepHashCode(this.bhg_1), 64) | 0;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof AudioSamples) {
      tmp_1 = this.zhf_1 === other.zhf_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.ahg_1 === other.ahg_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentDeepEquals(this.bhg_1, other.bhg_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'AudioSamples(channels=' + this.zhf_1 + ', totalSamples=' + this.ahg_1 + ')';
  }
}
class AudioSamplesInterleaved {
  constructor(channels, totalSamples, data) {
    data = data === VOID ? _AudioSampleArray___init__impl__qpxoq0_0(imul(totalSamples, channels)) : data;
    this.whg_1 = channels;
    this.xhg_1 = totalSamples;
    this.yhg_1 = data;
    var containsArg = this.whg_1;
    // Inline function 'kotlin.check' call
    if (!(1 <= containsArg ? containsArg <= 8 : false)) {
      throw IllegalStateException.o('Check failed.');
    }
  }
  dhg(channel, sample) {
    return AudioSampleArray__get_impl_w0l0xc(this.yhg_1, index(this, channel, sample));
  }
  rhh(channel, sample, value) {
    AudioSampleArray__set_impl_tqgfwk(this.yhg_1, index(this, channel, sample), value);
  }
  toString() {
    return 'AudioSamplesInterleaved(channels=' + this.whg_1 + ', totalSamples=' + this.xhg_1 + ')';
  }
}
class SoundListenerProps {}
function get_listenerPosition() {
  return Companion_getInstance().v9t_1;
}
class NativeSoundProvider {
  constructor() {
    this.shh_1 = 'unknown';
    this.thh_1 = false;
    this.uhh_1 = Companion_getInstance().v9t_1;
    this.vhh_1 = Companion_getInstance().x9t_1;
    this.whh_1 = Companion_getInstance().b9u_1;
    this.xhh_1 = Companion_getInstance().v9t_1;
  }
  eaa(_set____db54di) {
    this.thh_1 = _set____db54di;
  }
  yhh() {
    return this.uhh_1;
  }
  zhh(channels, frequency, gen) {
    return new AudioPlatformOutput(this, channels, frequency, gen);
  }
  f7() {
  }
}
class DummyNativeSoundProvider extends NativeSoundProvider {
  constructor() {
    Companion_getInstance_5();
    super();
  }
}
class Companion_2 extends DummyNativeSoundProvider {
  constructor() {
    Companion_instance_2 = null;
    super();
    Companion_instance_2 = this;
  }
}
class HtmlNativeSoundProvider extends NativeSoundProvider {
  constructor() {
    super();
    HtmlSimpleSound_getInstance().fhi();
  }
  zhh(channels, frequency, gen) {
    return new AudioPlatformOutput(this, channels, frequency, gen, VOID, HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda(frequency, channels));
  }
}
class sam$korlibs_io_lang_Cancellable$0 {
  constructor(function_0) {
    this.mhi_1 = function_0;
  }
  say(e) {
    return this.mhi_1(e);
  }
  p5() {
    return this.mhi_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Cancellable) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.p5(), other.p5());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.p5());
  }
}
class HtmlSimpleSound {
  constructor() {
    HtmlSimpleSound_instance = this;
    var tmp = this;
    var tmp_0;
    try {
      var tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      if (!(typeof window.AudioContext === 'undefined')) {
        tmp_1 = new AudioContext();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        if (!(typeof window.webkitAudioContext === 'undefined')) {
          tmp_1 = new webkitAudioContext();
        } else {
          tmp_1 = null;
        }
      }
      // Inline function 'kotlin.also' call
      var this_0 = tmp_1;
      // Inline function 'kotlin.js.asDynamic' call
      window.globalAudioContext = this_0;
      tmp_0 = this_0;
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var e = $p;
        console.error(e);
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp.ahi_1 = tmp_0;
    this.bhi_1 = false;
    var tmp_3 = this;
    // Inline function 'kotlin.also' call
    var this_1 = CompletableDeferred();
    var buf = ensureNotNull(HtmlSimpleSound_getInstance().ahi_1).createBuffer(1, 1, 22050);
    var unlock = {_v: null};
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var events = ['keydown', 'touchstart', 'touchend', 'mousedown'];
    unlock._v = HtmlSimpleSound$unlockDeferred$lambda(events, unlock, buf, this_1);
    var inductionVariable = 0;
    var last = events.length;
    while (inductionVariable < last) {
      var e_0 = events[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_4 = document;
      var tmp_5;
      if (unlock._v == null) {
        throwUninitializedPropertyAccessException('unlock');
      } else {
        tmp_5 = unlock._v;
      }
      tmp_4.addEventListener(e_0, tmp_5, true);
    }
    tmp_3.chi_1 = this_1;
    var tmp_6 = this;
    var tmp_7 = this.chi_1;
    tmp_6.dhi_1 = isInterface(tmp_7, Deferred) ? tmp_7 : THROW_CCE();
  }
  fhi() {
  }
  ehi(callback) {
    var cancelled = {_v: false};
    this.dhi_1.g1n(HtmlSimpleSound$callOnUnlocked$lambda(cancelled, callback));
    var tmp = HtmlSimpleSound$callOnUnlocked$lambda_0(cancelled);
    return new sam$korlibs_io_lang_Cancellable$0(tmp);
  }
}
//endregion
function AudioData$Companion$DUMMY$delegate$lambda() {
  return new AudioData(44100, new AudioSamples(2, 0));
}
var Companion_instance;
function Companion_getInstance_2() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
function AudioPlatformOutput$_init_$slambda_5e7gu6($channels) {
  return constructCallableReference(function *(_this__u8e3s4, $completion) {
    var buffer = new AudioSamplesInterleaved($channels, Companion_instance_0.fhg_1);
    while (_this__u8e3s4.shg_1) {
      _this__u8e3s4.vhg(buffer);
      yield* delay(new Long(1, 0), $completion);
    }
    return Unit_instance;
  }, 1);
}
function AudioPlatformOutput$start$slambda(this$0) {
  return constructCallableReference(function *($this$launch, $completion) {
    var tmp;
    try {
      tmp = yield* this$0.mhg_1(this$0, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException) {
        var e = $p;
        tmp_0 = Unit_instance;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    finally {
      this$0.shg_1 = false;
    }
    return Unit_instance;
  }, 1);
}
function _AudioSampleArray___init__impl__qpxoq0(data) {
  return data;
}
function _get_data__d5abxd($this) {
  return $this;
}
function _AudioSampleArray___init__impl__qpxoq0_0(size) {
  return _AudioSampleArray___init__impl__qpxoq0(new Int16Array(size));
}
function _AudioSampleArray___get_size__impl__8l8tm8($this) {
  return _get_data__d5abxd($this).length;
}
function AudioSampleArray__isEmpty_impl_81zmbn($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _get_data__d5abxd($this).length === 0;
}
function AudioSampleArray__iterator_impl_qvmfbu($this) {
  var shortIterator = shortArrayIterator(_get_data__d5abxd($this));
  return new AudioSampleArray$iterator$1(shortIterator);
}
function AudioSampleArray__containsAll_impl_ohplb0($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.n1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = elements.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var it = element.jhh_1;
      if (!AudioSampleArray__contains_impl_pmajf9($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function AudioSampleArray__containsAll_impl_ohplb0_0($this, elements) {
  return AudioSampleArray__containsAll_impl_ohplb0($this.ehg_1, elements);
}
function AudioSampleArray__contains_impl_pmajf9($this, element) {
  return contains(_get_data__d5abxd($this), _AudioSample___get_short__impl__uk8ygu(element));
}
function AudioSampleArray__contains_impl_pmajf9_0($this, element) {
  if (!(element instanceof AudioSample))
    return false;
  return AudioSampleArray__contains_impl_pmajf9($this.ehg_1, element instanceof AudioSample ? element.jhh_1 : THROW_CCE());
}
function AudioSampleArray__get_impl_w0l0xc($this, index) {
  return _AudioSample___init__impl__s54gd5(_get_data__d5abxd($this)[index]);
}
function AudioSampleArray__set_impl_tqgfwk($this, index, value) {
  _get_data__d5abxd($this)[index] = _AudioSample___get_short__impl__uk8ygu(value);
}
function AudioSampleArray__asShortArray_impl_iyd0md($this) {
  return _get_data__d5abxd($this);
}
function AudioSampleArray__fill_impl_cffij3($this, element, fromIndex, toIndex) {
  fill(_get_data__d5abxd($this), _AudioSample___get_short__impl__uk8ygu(element), fromIndex, toIndex);
}
function AudioSampleArray__fill$default_impl_gh9lh0($this, element, fromIndex, toIndex, $super) {
  fromIndex = fromIndex === VOID ? 0 : fromIndex;
  toIndex = toIndex === VOID ? _AudioSampleArray___get_size__impl__8l8tm8($this) : toIndex;
  var tmp;
  if ($super === VOID) {
    AudioSampleArray__fill_impl_cffij3($this, element, fromIndex, toIndex);
    tmp = Unit_instance;
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AudioSampleArray(tmp_0)).khh.call(new AudioSampleArray($this), new AudioSample(element), fromIndex, toIndex);
  }
  return tmp;
}
function AudioSampleArray__toString_impl_il1zfs($this) {
  return 'AudioSampleArray(data=' + toString($this) + ')';
}
function AudioSampleArray__hashCode_impl_363xd3($this) {
  return hashCode($this);
}
function AudioSampleArray__equals_impl_jso1e3($this, other) {
  if (!(other instanceof AudioSampleArray))
    return false;
  var tmp0_other_with_cast = other instanceof AudioSampleArray ? other.ehg_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _AudioSample___init__impl__s54gd5(raw) {
  return raw;
}
function _get_raw__e6fv55($this) {
  return $this;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function _AudioSample___init__impl__s54gd5_0(value) {
  return _AudioSample___init__impl__s54gd5(toShort(coerceIn(value, -32768, 32767)));
}
function _AudioSample___init__impl__s54gd5_1(value) {
  return _AudioSample___init__impl__s54gd5(toShort(coerceIn(numberToInt(value * 32767), -32768, 32767)));
}
function _AudioSample___get_short__impl__uk8ygu($this) {
  return _get_raw__e6fv55($this);
}
function _AudioSample___get_shortInt__impl__jh9fnx($this) {
  return _AudioSample___get_short__impl__uk8ygu($this);
}
function _AudioSample___get_float__impl__o6fgbi($this) {
  return _get_raw__e6fv55($this) / 32767;
}
function AudioSample__times_impl_3gw0k9($this, scale) {
  return _AudioSample___init__impl__s54gd5_0(numberToInt(_AudioSample___get_shortInt__impl__jh9fnx($this) * scale));
}
function AudioSample__toString_impl_8zwv0h($this) {
  return 'AudioSample(raw=' + $this + ')';
}
function AudioSample__hashCode_impl_cr91se($this) {
  return $this;
}
function AudioSample__equals_impl_tcgo7i($this, other) {
  if (!(other instanceof AudioSample))
    return false;
  if (!($this === (other instanceof AudioSample ? other.jhh_1 : THROW_CCE())))
    return false;
  return true;
}
function getSampled(_this__u8e3s4, channel, index) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.memory.getSampledGeneric' call
    var index0 = numberToInt(index);
    var v0 = new AudioSample(_this__u8e3s4.dhg(channel, index0));
    if (index0 === index) {
      tmp$ret$0 = v0.jhh_1;
      break $l$block;
    }
    var it = index0 + 1 | 0;
    var v1 = new AudioSample(_this__u8e3s4.dhg(channel, it));
    var ratio = index % 1.0;
    var tmp0 = v0.jhh_1;
    var scale = 1.0 - ratio;
    var o0 = _AudioSample___get_float__impl__o6fgbi(tmp0) * scale;
    var sample = v1.jhh_1;
    var o1 = _AudioSample___get_float__impl__o6fgbi(sample) * ratio;
    var it_0 = o0 + o1;
    tmp$ret$0 = _AudioSample___init__impl__s54gd5_1(it_0);
  }
  return tmp$ret$0;
}
function index($this, channel, sample) {
  return imul(sample, $this.whg_1) + channel | 0;
}
function get_AUDIO(_this__u8e3s4) {
  _init_properties_Dispatchers_AUDIO_kt__q7crgv();
  var tmp0 = AUDIO$delegate;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('AUDIO', 1, tmp, _get_AUDIO_$ref_bz9pai(), null);
  return tmp0.k3();
}
var AUDIO$delegate;
function AUDIO$delegate$lambda() {
  _init_properties_Dispatchers_AUDIO_kt__q7crgv();
  var tmp;
  if (Companion_getInstance_1().fb1()) {
    tmp = Dispatchers_getInstance().g1u();
  } else {
    tmp = FixedPoolNativeThreadDispatcher.k9x(16, 'AUDIO', Companion_getInstance_0().z9w_1, true);
  }
  return tmp;
}
function _get_AUDIO_$ref_bz9pai() {
  return constructCallableReference((p0) => get_AUDIO(p0), 1, 0, 367);
}
var properties_initialized_Dispatchers_AUDIO_kt_6wdlgz;
function _init_properties_Dispatchers_AUDIO_kt__q7crgv() {
  if (!properties_initialized_Dispatchers_AUDIO_kt_6wdlgz) {
    properties_initialized_Dispatchers_AUDIO_kt_6wdlgz = true;
    AUDIO$delegate = lazy(AUDIO$delegate$lambda);
  }
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 === VOID)
    new Companion_2();
  return Companion_instance_2;
}
function applyPropsTo(_this__u8e3s4, listener, samples) {
  var inductionVariable = 0;
  var last = samples.whg_1;
  if (inductionVariable < last)
    do {
      var ch = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var volume01 = volumeForChannel(_this__u8e3s4, listener, ch) * _this__u8e3s4.bhh();
      var inductionVariable_0 = 0;
      var last_0 = samples.xhg_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var sample = samples.dhg(ch, n);
          sample = AudioSample__times_impl_3gw0k9(sample, volume01);
          samples.rhh(ch, n, sample);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function volumeForChannel(_this__u8e3s4, listener, channel) {
  var distance = listener.yhh().g9u(_this__u8e3s4.wb6());
  return channel === 0 ? convertRangeClamped(_this__u8e3s4.dhh(), -1.0, 0.0, 0.0, 1.0) : 1.0 - convertRangeClamped(_this__u8e3s4.dhh(), 0.0, 1.0, 0.0, 1.0);
}
function get_nativeSoundProvider() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  var tmp0 = nativeSoundProvider$delegate;
  var tmp = KProperty0;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('nativeSoundProvider', 0, tmp, _get_nativeSoundProvider_$ref_yd9mqf(), null);
  return tmp0.k3();
}
var nativeSoundProvider$delegate;
function HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda$lambda$lambda($this_AudioPlatformOutput, $samples, $channels, $bufferSize, $scale) {
  return (e) => {
    $this_AudioPlatformOutput.vhg($samples);
    var inductionVariable = 0;
    var tmp;
    if (inductionVariable < $channels) {
      do {
        var ch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var outCh = e.outputBuffer.getChannelData(ch);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < $bufferSize)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'org.khronos.webgl.set' call
            // Inline function 'kotlin.js.asDynamic' call
            outCh[n] = _AudioSample___get_float__impl__o6fgbi(getSampled($samples, ch, n * $scale));
          }
           while (inductionVariable_0 < $bufferSize);
      }
       while (inductionVariable < $channels);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda$lambda($frequency, $channels, $node, $this_AudioPlatformOutput) {
  return (it) => {
    var ctx = HtmlSimpleSound_getInstance().ahi_1;
    var tmp;
    if (!(ctx == null)) {
      var bufferSize = 2048;
      var scale = $frequency / ctx.sampleRate;
      var samples = new AudioSamplesInterleaved($channels, numberToInt(bufferSize * scale));
      $node._v = ctx.createScriptProcessor(bufferSize, $channels, $channels);
      var tmp0_safe_receiver = $node._v;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.onaudioprocess = HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda$lambda$lambda($this_AudioPlatformOutput, samples, $channels, bufferSize, scale);
      }
      var tmp1_safe_receiver = $node._v;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver.connect(ctx.destination);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda($frequency, $channels) {
  return constructCallableReference(function *($this$AudioPlatformOutput, $completion) {
    get_nativeSoundProvider();
    var node = {_v: null};
    var tmp = HtmlSimpleSound_getInstance();
    var startPromise = tmp.ehi(HtmlNativeSoundProvider$createNewPlatformAudioOutput$slambda$lambda($frequency, $channels, node, $this$AudioPlatformOutput));
    var tmp_0;
    try {
      tmp_0 = yield* $this$AudioPlatformOutput.ehh($completion);
    }finally {
      if (startPromise == null)
        null;
      else {
        cancel(startPromise);
      }
      var tmp3_safe_receiver = node._v;
      if (tmp3_safe_receiver == null)
        null;
      else {
        tmp3_safe_receiver.disconnect();
      }
    }
    return Unit_instance;
  }, 1);
}
function nativeSoundProvider$delegate$lambda() {
  _init_properties_HtmlNativeSoundProvider_kt__ocy1lg();
  var tmp;
  if (Companion_getInstance_1().ib1()) {
    tmp = new HtmlNativeSoundProvider();
  } else {
    tmp = Companion_getInstance_5();
  }
  return tmp;
}
function _get_nativeSoundProvider_$ref_yd9mqf() {
  return constructCallableReference(() => get_nativeSoundProvider(), 0, 0, 368);
}
var properties_initialized_HtmlNativeSoundProvider_kt_uyp32m;
function _init_properties_HtmlNativeSoundProvider_kt__ocy1lg() {
  if (!properties_initialized_HtmlNativeSoundProvider_kt_uyp32m) {
    properties_initialized_HtmlNativeSoundProvider_kt_uyp32m = true;
    nativeSoundProvider$delegate = lazy(nativeSoundProvider$delegate$lambda);
  }
}
function HtmlSimpleSound$unlockDeferred$lambda$lambda($source, $unlockDeferred) {
  return () => {
    $source.disconnect(0);
    HtmlSimpleSound_getInstance().bhi_1 = true;
    console.info('Web Audio was successfully unlocked');
    $unlockDeferred.l1t(Unit_instance);
    return Unit_instance;
  };
}
function HtmlSimpleSound$unlockDeferred$lambda($events, $unlock, $buf, $unlockDeferred) {
  return (it) => {
    var indexedObject = $events;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var e = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = document;
      var tmp_0;
      if ($unlock._v == null) {
        throwUninitializedPropertyAccessException('unlock');
      } else {
        tmp_0 = $unlock._v;
      }
      tmp.removeEventListener(e, tmp_0, true);
    }
    HtmlSimpleSound_getInstance().ahi_1.resume();
    var source = HtmlSimpleSound_getInstance().ahi_1.createBufferSource();
    source.onended = HtmlSimpleSound$unlockDeferred$lambda$lambda(source, $unlockDeferred);
    source.buffer = $buf;
    source.connect(HtmlSimpleSound_getInstance().ahi_1.destination);
    source.start(0.0);
    HtmlSimpleSound_getInstance().ahi_1.resume();
    return Unit_instance;
  };
}
function HtmlSimpleSound$callOnUnlocked$lambda($cancelled, $callback) {
  return (it) => {
    if (!$cancelled._v)
      $callback(Unit_instance);
    return Unit_instance;
  };
}
function HtmlSimpleSound$callOnUnlocked$lambda_0($cancelled) {
  return (it) => {
    $cancelled._v = true;
    return Unit_instance;
  };
}
var HtmlSimpleSound_instance;
function HtmlSimpleSound_getInstance() {
  if (HtmlSimpleSound_instance === VOID)
    new HtmlSimpleSound();
  return HtmlSimpleSound_instance;
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AudioData, 'AudioData');
initMetadataForCompanion(Companion_0);
initMetadataForInterface(ReadonlySoundProps, 'ReadonlySoundProps');
initMetadataForInterface(SoundProps, 'SoundProps', VOID, VOID, [ReadonlySoundProps]);
protoOf(AudioPlatformOutput).hhh = set_pitch;
protoOf(AudioPlatformOutput).ihh = get_pitch_0;
initMetadataForClass(AudioPlatformOutput, 'AudioPlatformOutput', VOID, VOID, [AutoCloseable, SoundProps], [0]);
initMetadataForClass(AudioSampleArray$iterator$1);
initMetadataForClass(AudioSampleArray, 'AudioSampleArray', VOID, VOID, [Collection]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(AudioSample, 'AudioSample');
initMetadataForClass(AudioSamples, 'AudioSamples');
initMetadataForClass(AudioSamplesInterleaved, 'AudioSamplesInterleaved');
initMetadataForInterface(SoundListenerProps, 'SoundListenerProps');
initMetadataForClass(NativeSoundProvider, 'NativeSoundProvider', NativeSoundProvider, VOID, [AutoCloseable, SoundListenerProps]);
initMetadataForClass(DummyNativeSoundProvider, 'DummyNativeSoundProvider', DummyNativeSoundProvider);
initMetadataForCompanion(Companion_2);
initMetadataForClass(HtmlNativeSoundProvider, 'HtmlNativeSoundProvider', HtmlNativeSoundProvider);
initMetadataForClass(sam$korlibs_io_lang_Cancellable$0, 'sam$korlibs_io_lang_Cancellable$0', VOID, VOID, [Cancellable, FunctionAdapter]);
initMetadataForObject(HtmlSimpleSound, 'HtmlSimpleSound', VOID, VOID, VOID, [0, 2, 1]);
//endregion
//region block: init
Companion_instance_0 = new Companion_0();
//endregion
//region block: exports
export {
  AudioSampleArray__fill$default_impl_gh9lh0 as AudioSampleArray__fill$default_impl_gh9lh03uipedjkshpvd,
  _AudioSample___init__impl__s54gd5 as _AudioSample___init__impl__s54gd528mhgozdh1bqj,
  _AudioSample___get_short__impl__uk8ygu as _AudioSample___get_short__impl__uk8ygu1ahnse94tkd3h,
  _AudioSampleArray___init__impl__qpxoq0 as _AudioSampleArray___init__impl__qpxoq02v35zbbobd74i,
  AudioSampleArray__asShortArray_impl_iyd0md as AudioSampleArray__asShortArray_impl_iyd0md3ucruvh93ttmk,
  AudioSampleArray__get_impl_w0l0xc as AudioSampleArray__get_impl_w0l0xcb5gy68blt832,
  AudioSampleArray__set_impl_tqgfwk as AudioSampleArray__set_impl_tqgfwk1pug7fxkhzjb,
  _AudioSampleArray___get_size__impl__8l8tm8 as _AudioSampleArray___get_size__impl__8l8tm833qpwjtzx85jt,
  Companion_instance_0 as Companion_instance2dqi4vf5r525o,
  Companion_getInstance_4 as Companion_getInstance1rxbh6e5ak2m2,
  AudioData as AudioData3ewbxcbopprh8,
  AudioSampleArray as AudioSampleArray262uyoodhuuvf,
  AudioSamples as AudioSamples3pmkh9en9mrjs,
  ReadonlySoundProps as ReadonlySoundProps270enpa6r4amt,
  SoundProps as SoundProps3stqh6vq4ra4p,
  get_nativeSoundProvider as get_nativeSoundProvider1b6rsunmfcp5k,
};
//endregion
